<template>
    <BaseDropdown position="left">
        <template #trigger>
            <ModuleTag
                v-if="searchModule"
                :icon="$getModuleIcon(searchModule.name)"
                :label="$t(searchModule.name + '.table.title')"
                :module="searchModule.name">
                <template
                    v-if="searchables?.length"
                    #append>
                    <Icon
                        name="heroicons:chevron-down-16-solid"
                        class="w-4 h-4" />
                </template>
            </ModuleTag>
            <ModuleTag
                v-else
                grayed-out
                icon="heroicons:bars-3-bottom-left"
                :label=" $t('globalSearch.everything')">
                <template
                    v-if="searchables?.length"
                    #append>
                    <Icon
                        name="heroicons:chevron-down-16-solid"
                        class="w-4 h-4" />
                </template>
            </ModuleTag>
        </template>
        <BaseMenuItem @click="globalSearchStore.setCurrentModule(null)">
            <ModuleTag
                reduced
                grayed-out
                icon="heroicons:bars-3-bottom-left"
                :label=" $t('globalSearch.everything')" />
            <span :class="{'font-bold': !searchModule?.name}">
                {{ $t('globalSearch.everything') }}
            </span>
        </BaseMenuItem>
        <BaseMenuItem
            v-for="searchable in searchables"
            :key="searchable"
            @click="globalSearchStore.setCurrentModule(searchable)">
            <ModuleTag
                reduced
                :icon="$getModuleIcon(searchable)"
                :label="$t(searchable + '.table.title')"
                :module="searchable" />
            <span :class="{'font-semibold': searchModule?.name === searchable}">
                {{ $t(searchable + '.table.title') }}
            </span>
        </BaseMenuItem>
    </BaseDropdown>
</template>

<script setup lang="ts">
import {useGlobalSearchStore} from '@/store/globalSearch'
import {$getModuleIcon, appModules} from "@/utils/appModules"

const globalSearchStore = useGlobalSearchStore()

const searchModule = computed(() => {
    return appModules[globalSearchStore.currentModule] ?? null
})

const searchables = computed(() => Object.keys(appModules).filter(module => appModules[module].search))

</script>

<style scoped>

</style>